"use client";
import Link from "next/link";
import { Fragment } from "react";
import { slugifyTag } from "../../../../utils/tagSlug";

export function Tags({ tags }: { tags: Array<string> }) {
  return (
    <ul aria-label="Tags" className="flex space-x-2">
      {tags.map((baseTag) => {
        const slugTag = slugifyTag(baseTag);
        return (
          <Fragment key={baseTag}>
            <li>
              <Link href={`/writing/tags/${slugTag}`} passHref legacyBehavior>
                <a className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-200 text-gray-800 border hover:bg-gray-400">
                  {baseTag}
                </a>
              </Link>
            </li>
          </Fragment>
        );
      })}
    </ul>
  );
}
